/**
 * Gets initials from a string, up to two characters.
 * @category Getters
 * @category String
 */
export default function getInitials(word) {
  if (!word) {
    return '';
  }
  const trimmedWord = word.trim();
  if (trimmedWord.length === 0) {
    return '';
  }
  const parts = trimmedWord.split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}